module.exports = __webpack_public_path__ + "static/gray_car-073300e39ac992e760a312dd93e7fcc4.gif";